<template>
  <div :style="isIndex ? 'overflow: hidden;' : ''">
    <Head v-if="!isIndex" />
    <WapHeader v-if="isIndex" />
    <div class="index-banner-home">
      <div
        class="carousel"
        :class="{ 'no-interaction': videoIsPlay }"
        @mousedown.stop="startDrag"
        @mouseup.stop="endDrag"
        @mouseleave.stop="endDrag"
        @dblclick.stop="handleDoubleClick"
        @touchstart.stop="startDrag"
        @touchmove.stop="drag"
        @touchend.stop="endDrag"
      >
        <div class="carousel-slides" ref="slides" @mousemove.stop="drag" @touchmove.stop="drag">
          <div
            v-for="(slide, index) in homeBannerList"
            @click.stop.prevent="isIndexGoTo(slide)"
            :key="index"
            :class="{ 'carousel-slide': true, active: currentIndex === index }"
          >
            <div class="banner-bg-wrapper" v-if="slide.video">
              <video
                :controls="false"
                class="video"
                :ref="`vueMiniPlayer${index}`"
                :playsinline="true"
                muted
                @play="onVideoPlay"
                @pause="onVideoPause"
                @ended="onVideoEnded"
              >
                <source :src="slide.video" type="video/mp4" />
                您的浏览器不支持Video标签。
              </video>
              <!-- 条件渲染覆盖图片 -->
              <img
                v-if="videoPaused"
                src="../assets/banner1.jpg"
                alt="视频暂停"
                class="overlay-image"
              />
            </div>
            <div class="banner-bg-wrapper" v-else>
              <img class="pc" :src="slide.img" alt="" />
              <img class="wap" :src="slide.img" alt="" />
            </div>
            <div class="banner-heart" v-if="!videoIsPlay">
              <div class="home-img-info">
                <div class="home-img-title" v-if="slide.advertCnName">
                  {{ lan ? slide.advertEnName : slide.advertCnName }}
                </div>
                <div class="home-img-author" v-if="slide.advertCnDesc">
                  {{ lan ? slide.advertEnDesc : slide.advertCnDesc }}
                </div>
                <div class="home-img-dec" v-if="slide.advertCnList">
                  {{ lan ? slide.advertEnList[0] : slide.advertCnList[0] }}
                  <br />
                  {{
                    slide.advertCnList.length > 1 && lan
                      ? slide.advertEnList[1]
                      : slide.advertCnList[1]
                  }}
                </div>
                <div
                  v-if="slide.link != ''"
                  class="home-img-btn"
                  @mouseover="hoverShow = true"
                  @mouseleave="hoverShow = false"
                >
                  <a
                    v-if="slide.link != ''"
                    :href="slide.link"
                    @click="slideGoTo(slide.link)"
                    target="_blank"
                    rel="nofollow"
                  >
                    <img
                      v-if="!hoverShow && lan"
                      src="../assets/Detail-wan.png"
                      alt=""
                    />
                    <img
                      v-else-if="!hoverShow && !lan"
                      src="../assets/Detail-w.png"
                      alt=""
                    />
                    <img
                      v-else-if="hoverShow && lan"
                      src="../assets/Detail-lan.png"
                      alt=""
                    />
                    <img
                      v-else-if="hoverShow && !lan"
                      src="../assets/Detail-l.png"
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home-swiper-pagination">
        <!-- <div class="mouse-move-to" v-if="!videoIsPlay">
          <img src="../assets/mouse.png" alt="" />
        </div> -->
        <div
          class="video-click"
          @click.stop.prevent="onVideo"
          v-if="
            homeBannerList[currentIndex] && homeBannerList[currentIndex].video
          "
        >
          <img
            v-if="videoIsPlay"
            src="../assets/videoPaused.png"
            alt="视频暂停"
            class="video-click-img"
          />
          <img
            v-else
            src="../assets/videoPlay.png"
            alt="视频开始"
            class="video-click-img"
          />
        </div>
        <div class="carousel-pagination" v-if="!videoIsPlay">
          <div
            v-for="(_, index) in indexBanner"
            :key="index"
            :class="{
              'carousel-pagination-button': true,
              active: indexBannerIndex === index,
            }"
            @click.stop.prevent="goToSlide(index)"
          ></div>
        </div>
      </div>
    </div>
    <div class="content">
      <div>
        <HomeShowBox v-if="!isIndex" :showData="exhibitionData" />
        <HomeShowWap v-else :showData="exhibitionData" />
      </div>
      <div>
        <ActHomeData v-if="!isIndex" :showData="actData" :showType="1" />
        <HomeShowWap v-else :showData="actData" :showType="1" />
      </div>
      <div class="show-act-box">
        <div class="content-title">
          <div class="title-left">{{ lan ? "Architecture" : "建筑" }}</div>
          <div class="title-right" @click="goToArchitecture">
            {{ lan ? "MORE" : "查看全部"
            }}<img
              class="youjiantou"
              src="../assets/youjiantou_grey@2x.png"
              alt=""
            />
          </div>
        </div>
        <div class="sub-title-Architecture">
          {{
            lan
              ? "Modernity Spatial Structures in Alignment with the Scale of the Ancient Lingnan Village"
              : "与岭南古村尺度相宜的现代性空间"
          }}
        </div>
        <div class="act-list">
          <ExhibitionBox
            :showData="item"
            :showType="1"
            :showIndex="index"
            v-for="(item, index) in architecture"
            :key="item.id"
            @click.native="goToArchitectureWithIndex(index)"
          />
        </div>
      </div>
    </div>
    <Bottom v-if="!isIndex" />
    <WapBottom v-if="isIndex" />
  </div>
</template>

<script>
// @ is an alias to /src
import Head from "@/components/header";
import WapHeader from "@/components/wapHeader";
import Bottom from "@/components/bottom";
import WapBottom from "@/components/wapBottom";
import HomeShowBox from "./components/homeShowBox";
import HomeShowWap from "./components/homeShowWap";
import ExhibitionBox from "./components/exhibitionBox";
import ActHomeData from "./components/actHomeData";
import "swiper/dist/css/swiper.css";
export default {
  name: "Home",
  components: {
    Head,
    Bottom,
    HomeShowBox,
    ExhibitionBox,
    ActHomeData,
    HomeShowWap,
    WapBottom,
    WapHeader,
  },
  filters: {
    num(value) {
      let result = "";
      let counter = 0;
      value = (value || 0).toString();
      for (let i = value.length - 1; i >= 0; i--) {
        counter++;
        result = value.charAt(i) + result;
        if (!(counter % 3) && i !== 0) {
          result = "," + result;
        }
      }
      return result;
    },
  },
  data() {
    return {
      indexBanner: [],
      exhibitionData: {},
      actData: {},
      actId: "",
      exhibitionId: "",
      homeBannerList: [],
      entrance: [],
      architecture: [
        {
          id: 1,
          imageUrl: require("@/assets/OnArchitecture1.jpg"),
          title: "聚落式格局",
          titleEn: "Building Units Layout",
          info: "春阳台采用了与古村相呼应的聚落式格局，将展览、阅读、观演、研学、餐饮等功能分散布置在十座单体建筑中。其中七座单体建筑间以弧形的楼相串连，围合出尺度宜人的街巷与庭院，并消解了大体量建筑对古村环境的压迫感，呈现出一种诗意的融合。",
          infoEn:
            "Establishing connections with the scale and layout of the ancient village, the programs of the complex – exhibition spaces, library, theater, research studios, and café – are dispersed into ten individual small building units. Seven of these building units, connected by arc structures, together form alleys and courtyards of a delightful scale and dispel the sense of formidability posed by the massive building complex to the environment of the ancient village, presenting a poetic fusion.",
        },
        {
          id: 2,
          imageUrl: require("@/assets/OnArchitecture2.jpg"),
          title: "月牙窗",
          titleEn: "Crescent Windows",
          info: "作为对“龙船脊”以及“月梁”等岭南建筑元素的当代演绎，建筑立面上的月牙形开窗既为建筑内部空间带来更加微妙柔和的采光，又能成为透视周边乡野美景的弧形画框，是春阳台标志性的建筑符号。",
          infoEn:
            "As a contemporary interpretation of traditional Lingnan architectural elements such as “Dragon boat ridge” and “Moon beam”, the crescent windows bring not only subtle and soft lighting into the interior spaces but also serve as an arc-shaped frame for observing the surroundings. It has become the iconic architectural symbol of ChunYangTai.",
        },
        {
          id: 3,
          imageUrl: require("@/assets/OnArchitecture3.jpg"),
          title: "弧形“楼”",
          titleEn: "Curved Towers",
          info: "单体建筑通过弧形的“楼”相串联，同时也围合出尺度怡人的街巷与庭院。",
          infoEn:
            "Building units are connected by “towers” with curvilinear brick walls and form alleys and courtyards of intimate sizes in between.",
        },
        {
          id: 4,
          imageUrl: require("@/assets/OnArchitecture4.jpg"),
          title: "立体荷塘",
          titleEn: "Multi-level Lotus Pond",
          info: "建筑屋面设置了二十五组不同尺寸的种植池，其中茂盛的水生植物既是野趣的景观，也降低了建筑能耗。架空步道蜿蜒于屋面，从这里望去，种植池与下沉水院、周边的天然荷塘相互呼应，使春阳台成为一座融入环境、高低错落的“立体荷塘”。",
          infoEn:
            'We have placed nearly 30 groups of planted water ponds of different sizes on the roofs of buildings. The lush aquatic plants in the ponds not only form a natural landscape but also reduce the energy consumption of the buildings. The roof ponds, connected by elevated walkways, along with the natural ponds in the surrounding areas and the sunken courtyards, make ChunYangTai a "multi-level lotus pond system" that blends into nature.',
        },
        {
          id: 5,
          imageUrl: require("@/assets/OnArchitecture5.jpg"),
          title: "双向剧场及看台",
          titleEn: "Double-sided Theater",
          info: "剧场的舞台背面设有一整扇可以自动开合的门。每当门徐徐打开，观众便可从剧场内看到对面荷塘中的双向看台，游客端坐其中，或漫步周围，共同构成人景共生的美妙画面。",
          infoEn:
            "There is a door in the back of the stage of the theater that can open and close automatically. When the door opens slowly, the audience inside the theater can see the double-sided stand in the lotus pond on the opposite side of the theater. Visitors sitting in the stand or wandering around the area thus become part of the scenery.",
        },
        {
          id: 6,
          imageUrl: require("@/assets/OnArchitecture6.jpg"),
          title: "传统材质与技艺创新",
          titleEn: "Innovations of Traditional Materials and Building Techniques",
          info: "在选材上，通过对塱头传统乡土建筑进行的类型学调研与分析，春阳台确定了最具地域代表性的核心材料：红瓦和青砖，并与木模清水混凝土结合。在建设过程中，建筑材料部分参照传统工艺规范，如红瓦砌法源自当地的“双坡叠砌”，青砖则采用“全顺砌筑”。现代材料则采用了高性能混凝土和节能玻璃等，但都经过了与传统环境的适配性测试。其次在建造技艺方面，春阳台在尊重传统智慧的基础上，混凝土采用窄条木板做浇筑模板，以模拟手工砖墙的肌理效果。通风巷道的设计遵循了岭南民居“冷巷”的原理，并将传统砌筑巷道优化为混凝土框架与镂空瓦墙的复合构造。",
          infoEn:
            "Typological study of traditional rural architecture in Langtou was first conducted to identify the most regionally representative materials, namely, red clay tiles and grey bricks, which were then integrated with board-formed concrete in ChunYangTai. During construction, traditional materials drew reference from local craftsmanship standards: red tiles were laid using the local double-slope stacking method, and the grey bricks employed the standard flush bonding technique. Modern materials such as high-performance concrete and energy-efficient glass were also used, but only after compatibility testing to ensure harmonious integration with the historic environment. For instance, the façade's concrete mix was selected after multiple rounds of material testing to meet structural requirements while achieving a surface texture that engages in a respectful visual dialogue with traditional materials. The steel structural components, prefabricated off-site and assembled on location, improved construction precision and minimised disruption to the historic village environment.In terms of construction techniques, the new architecture introduces innovations grounded in respect for traditional craftsmanship. For example, narrow timber planks were used as concrete formwork to simulate the texture of hand-laid brick walls. The green roof system integrates modern technologies such as automated irrigation and waterproof root barriers. The ventilation alleyways were designed in accordance with the 'cold alley' thermal principle found in traditional Lingnan dwellings, and the traditional brick passageways were adapted into a composite structure of concrete framing and perforated brick walls for improved performance and durability.",
        },
      ],
      hoverShow: false,
      currentIndex: 1, // 当前显示的轮播图索引
      indexBannerIndex: 0, // 当前显示的轮播图索引
      startX: 0,
      startY: 0,
      startTime: 0,
      dragging: false,
      threshold: 30, // 降低滑动阈值，从50像素降低到30像素
      velocityThreshold: 0.3, // 滑动速度阈值 (像素/毫秒)
      thresholdShow: false, // 滑动阈值，单位为像素
      lan: this.$store.state.isEn,
      screenWidth: 1024,
      isIndex: false,
      videoIsPlay: false, // 视频是否播放
      videoPaused: true, // 视频是否暂停
      lastWheelTime: 0, // 鼠标滚轮防抖时间戳
      wheelScrolling: false, // 鼠标滚轮滚动锁定标志
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  created() {
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  mounted() {
    this.init();
    // this.startAutoplay();
    if (this.isIndex) {
      window.addEventListener("touchstart", this.startDrag);
      window.addEventListener("touchmove", this.drag);
      window.addEventListener("touchend", this.endDrag);
    }
    // 添加鼠标滚轮事件监听
    this.$el.addEventListener("wheel", this.handleWheel, { passive: true });
    
    // 添加全局鼠标事件监听器，以防快速拖动时丢失事件
    document.addEventListener('mouseup', this.handleGlobalMouseUp);
    document.addEventListener('mouseleave', this.handleGlobalMouseUp);
  },
  beforeDestroy() {
    if (this.isIndex) {
      window.removeEventListener("touchstart", this.startDrag);
      window.removeEventListener("touchmove", this.drag);
      window.removeEventListener("touchend", this.endDrag);
    }
    // 移除鼠标滚轮事件监听器
    this.$el.removeEventListener("wheel", this.handleWheel);
    clearInterval(this.autoplayInterval);
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
    
    // 移除全局鼠标事件监听器
    document.removeEventListener('mouseup', this.handleGlobalMouseUp);
    document.removeEventListener('mouseleave', this.handleGlobalMouseUp);
    document.removeEventListener('mousemove', this.handleGlobalMouseMove);
  },
  methods: {
    // 全局鼠标释放处理函数
    handleGlobalMouseUp(event) {
      if (this.dragging) {
        this.endDrag(event);
      }
    },
    
    // 全局鼠标移动处理函数
    handleGlobalMouseMove(event) {
      if (this.dragging) {
        this.drag(event);
      }
    },
    
    checkFirstSlideForVideo() {
      // 确保 homeBannerList 已经被填充
      if (this.homeBannerList.length > 0) {
        const firstSlide = this.homeBannerList[1];
        if (firstSlide.video) {
          // 如果第一个幻灯片是视频，自动播放
          const videoObj =
            (this.$refs[`vueMiniPlayer1`] && this.$refs[`vueMiniPlayer1`][0]) ||
            null;
          if (videoObj) {
            videoObj.play().catch((error) => {
              console.error("播放错误:", error);
            });
            this.videoIsPlay = true; // 更新视频播放状态
            this.videoPaused = false; // 更新视频暂停状态
          }
        }
      }
    },
    isIndexGoTo(slide) {
      if (this.isIndex && slide.link) {
        window.open(slide.link, "_blank");
      } else if (slide.videolist) {
        clearInterval(this.autoplayInterval); // 暂停轮播
      }
    },
    slideGoTo(slide) {
      if (slide) {
        window.open(slide, "_blank");
      }
    },
    handleMediaQueryChange(event) {
      if (event.matches) {
        this.isIndex = false;
        this.init();
      } else {
        this.isIndex = true;
        this.init();
      }
    },
    async init() {
      await this.$api.get(
        "/advert/list",
        { current: 1, pageSize: 10, advertFlagName: "home_banner" },
        (r) => {
          const { data, code } = r;
          if (code == 0) {
            data.forEach((el) => {
              if (!el.video) {
                el.img = (el.image && JSON.parse(el.image)[0].src) || "";
              }
            });
            this.indexBanner = JSON.parse(JSON.stringify(data));
            this.homeBannerList = [
              { ...this.indexBanner[this.indexBanner.length - 1] },
              ...this.indexBanner,
              { ...this.indexBanner[0] },
            ];
            this.indexBanner.forEach((el) => {
              el.advertCnList = el.advertCnDetail.split("&&&");
              el.advertEnList = el.advertEnDetail.split("&&&");
            });
            // 在组件挂载后判断第一个幻灯片是否为视频
            setTimeout(() => {
              this.checkFirstSlideForVideo();
            }, 500);
          }
        }
      );
      await this.$api.get(
        "/advert/list",
        { current: 1, pageSize: 10, advertFlagName: "exhibition_recommend" },
        (res) => {
          const { data, code } = res;
          if (code == 0) {
            data[0].imgList = data[0].image && JSON.parse(data[0].image);
            this.exhibitionData = data[0];
            this.exhibitionId = data[0].advertCnDetail;
          }
        }
      );
      await this.$api.get(
        "/advert/list",
        { current: 1, pageSize: 10, advertFlagName: "act_recommend" },
        (res) => {
          const { data, code } = res;
          if (code == 0) {
            data[0].imgList = data[0].image && JSON.parse(data[0].image);
            this.actData = data[0];
            this.actId = data[0].advertCnDetail;
          }
        }
      );
    },
    goToArchitecture() {
      // 跳转到建筑部分并打开第一个弹窗（索引为0）
      this.$router.push({
        name: "aboutCY",
        query: {
          columnId: 1,
          index: 0, // 查看全部时默认显示第一个
        },
        hash: "#architecture",
      });
    },

    // 添加带索引的跳转方法
    goToArchitectureWithIndex(index) {
      this.$router.push({
        name: "aboutCY",
        query: {
          columnId: 1,
          index: index, // 传递具体的索引
        },
        hash: "#architecture",
      });
    },
    startDrag(event) {
        // 如果视频正在播放，则不允许拖拽切换
        if (this.videoIsPlay) return;
        
        // 添加全局鼠标移动和释放事件监听器，提高响应性
        document.addEventListener('mousemove', this.handleGlobalMouseMove);
        document.addEventListener('mouseup', this.handleGlobalMouseUp);
        document.addEventListener('touchmove', this.handleGlobalMouseMove, { passive: false });
        document.addEventListener('touchend', this.handleGlobalMouseUp);
        
        if (event.touches) {
            this.startX = this.isIndex ? event.touches[0].clientX : event.clientX;
            this.startY = event.touches[0].clientY;
        } else {
            this.startX = event.clientX;
            this.startY = event.clientY;
        }
        this.startTime = new Date().getTime();
        this.dragging = true;
        
        // 添加实时拖拽预览效果
        this.$refs.slides.style.transition = "none";
    },
    drag(event) {
        // 如果视频正在播放，则不允许拖拽切换
        if (this.videoIsPlay) return;
        
        if (!this.dragging || this.isTransitioning) return;
        let deltaX = 0;
        let deltaY = 0;
        
        if (this.isIndex && event.touches) {
            deltaX = event.touches[0].clientX - this.startX;
            deltaY = event.touches[0].clientY - this.startY;
        } else if (event.touches) {
            deltaX = event.touches[0].clientX - this.startX;
            deltaY = event.touches[0].clientY - this.startY;
            // 阻止默认滚动行为，但仅在水平拖拽时
            if (Math.abs(deltaX) > Math.abs(deltaY)) {
                event.preventDefault();
            }
        } else {
            deltaX = event.clientX - this.startX;
            deltaY = event.clientY - this.startY;
            // 阻止默认滚动行为，但仅在水平拖拽时
            if (Math.abs(deltaX) > Math.abs(deltaY)) {
                event.preventDefault();
            }
        }
        
        // 如果垂直滑动距离大于水平滑动距离，则不处理滑动
        if (Math.abs(deltaY) > Math.abs(deltaX)) {
            return;
        }
        
        // 当拖拽距离过大时自动结束拖拽
        const maxDragDistance = window.innerWidth * 0.3; // 最大拖拽距离为屏幕宽度的30%
        if (Math.abs(deltaX) > maxDragDistance) {
            // 触发自动结束拖拽
            this.autoEndDrag(deltaX);
            return;
        }
        
        // 实时预览拖拽效果
        const translateX = -this.currentIndex * 100 + (deltaX / window.innerWidth) * 100;
        this.$refs.slides.style.transform = `translateX(${translateX}%)`;
    },
    // 自动结束拖拽的方法
    autoEndDrag(deltaX) {
        if (!this.dragging) return;
        
        // 清除自动播放定时器
        clearInterval(this.autoplayInterval);
        
        // 结束拖拽状态
        this.dragging = false;
        
        // 根据拖拽方向决定切换到上一张还是下一张
        const video =
            (this.$refs[`vueMiniPlayer${this.currentIndex}`] &&
                this.$refs[`vueMiniPlayer${this.currentIndex}`][0]) ||
            null;
        video && video.pause();
        
        if (deltaX > 0) {
            // 右滑，切换到上一张
            this.prevSlide();
        } else {
            // 左滑，切换到下一张
            this.nextSlide();
        }
        
        // 重启自动播放
        this.startAutoplay();
    },
    endDrag(event) {
        // 移除全局事件监听器
        document.removeEventListener('mousemove', this.handleGlobalMouseMove);
        document.removeEventListener('mouseup', this.handleGlobalMouseUp);
        document.removeEventListener('touchmove', this.handleGlobalMouseMove);
        document.removeEventListener('touchend', this.handleGlobalMouseUp);
        
        if (!this.dragging) return;
        clearInterval(this.autoplayInterval);
        
        let deltaX = 0;
        let deltaY = 0;
        
        if (this.isIndex && event.changedTouches) {
            deltaX = event.changedTouches[0].clientX - this.startX;
            deltaY = event.changedTouches[0].clientY - this.startY;
        } else if (event.changedTouches) {
            deltaX = event.changedTouches[0].clientX - this.startX;
            deltaY = event.changedTouches[0].clientY - this.startY;
        } else {
            deltaX = event.clientX - this.startX;
            deltaY = event.clientY - this.startY;
        }
        
        // 如果垂直滑动距离大于水平滑动距离，则不处理滑动
        if (Math.abs(deltaY) > Math.abs(deltaX)) {
            this.$refs.slides.style.transition = "transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)";
            this.$refs.slides.style.transform = `translateX(-${this.currentIndex * 100}%)`;
            this.dragging = false;
            this.startAutoplay();
            return;
        }
        
        // 限制水平滑动范围，避免图片跟随鼠标过度移动
        const maxDragDistance = window.innerWidth * 0.5; // 最大拖拽距离为屏幕宽度的一半
        if (Math.abs(deltaX) > maxDragDistance) {
            deltaX = deltaX > 0 ? maxDragDistance : -maxDragDistance;
        }
        
        const deltaTime = new Date().getTime() - this.startTime;
        const velocity = Math.abs(deltaX) / deltaTime; // 滑动速度 (像素/毫秒)
        
        // 结合距离和速度的判断逻辑
        if (Math.abs(deltaX) > this.threshold || velocity > this.velocityThreshold) {
            const video =
                (this.$refs[`vueMiniPlayer${this.currentIndex}`] &&
                    this.$refs[`vueMiniPlayer${this.currentIndex}`][0]) ||
                null;
            video && video.pause();
            
            if (deltaX > 0) {
                // 右滑，切换到上一张
                this.prevSlide();
            } else {
                // 左滑，切换到下一张
                this.nextSlide();
            }
        } else {
            // 回到原来的位置
            this.$refs.slides.style.transition = "transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)";
            this.$refs.slides.style.transform = `translateX(-${this.currentIndex * 100}%)`;
        }

        this.dragging = false;
        this.startAutoplay(); // 重启自动播放
    },
    handleDoubleClick(event) {
        // 双击时确保拖拽状态被正确重置
        if (this.dragging) {
            this.dragging = false;
            this.$refs.slides.style.transition = "transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)";
            this.$refs.slides.style.transform = `translateX(-${this.currentIndex * 100}%)`;
            this.startAutoplay();
        }
    },
    nextSlide() {
        this.thresholdShow = true;
        this.currentIndex = (this.currentIndex + 1) % this.homeBannerList.length;
        this.$refs.slides.style.transition = `transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)`;
        this.$refs.slides.style.transform = `translateX(-${100 * this.currentIndex}%)`;

        // 当到达克隆的最后一张时，跳转回真实的第一张
        if (this.currentIndex === this.homeBannerList.length - 1) {
            this.indexBannerIndex = 0;
            setTimeout(() => {
                this.$refs.slides.style.transition = `transform 0s ease`;
                this.$refs.slides.style.transform = `translateX(-100%)`;
                this.currentIndex = 1;
                this.thresholdShow = false;
            }, 600);
        } else {
            this.indexBannerIndex = this.currentIndex - 1;
            setTimeout(() => {
                this.thresholdShow = false;
            }, 600);
        }
    },
    prevSlide() {
        this.thresholdShow = true;
        this.currentIndex = (this.currentIndex - 1 + this.homeBannerList.length) % this.homeBannerList.length;
        this.$refs.slides.style.transition = "transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)";
        this.$refs.slides.style.transform = `translateX(-${100 * this.currentIndex}%)`;

        // 当到达克隆的第一张时，跳转回真实的最后一张
        if (this.currentIndex === 0) {
            this.indexBannerIndex = this.indexBanner.length - 1;
            setTimeout(() => {
                this.$refs.slides.style.transition = "transform 0s ease";
                this.$refs.slides.style.transform = `translateX(-${100 * (this.homeBannerList.length - 2)}%)`;
                this.currentIndex = this.homeBannerList.length - 2;
                this.thresholdShow = false;
            }, 600);
        } else {
            this.indexBannerIndex = this.currentIndex - 1;
            setTimeout(() => {
                this.thresholdShow = false;
            }, 600);
        }
    },
    goToSlide(index) {
        // 如果视频正在播放，则不允许点击分页按钮切换
        if (this.videoIsPlay) return;
        
        if (this.thresholdShow) return; // 如果正在执行动画，则不执行
        clearInterval(this.autoplayInterval);
        this.thresholdShow = true;
        // 确保索引在有效范围内
        index = Math.max(0, Math.min(index, this.indexBanner.length - 1));
        // 如果当前已经是这个索引，则不执行任何操作，但需要重置thresholdShow状态
        if (this.indexBannerIndex === index) {
            // 添加一个延迟重置，确保状态能正确恢复
            setTimeout(() => {
                this.thresholdShow = false;
                this.startAutoplay();
            }, 100);
            return;
        }
        // 更新索引
        this.currentIndex = index + 1; // 考虑到克隆的首张图片
        this.indexBannerIndex = index;
        
        // 应用过渡效果（如果需要的话）
        this.$refs.slides.style.transition = "transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)"; // 更流畅的缓动函数，缩短动画时间
        // 跳转到指定的幻灯片位置
        this.$refs.slides.style.transform = `translateX(-${
            100 * this.currentIndex
        }%)`;
        // 如果需要，更新其他相关的索引或状态
        setTimeout(() => {
            this.thresholdShow = false;
            this.startAutoplay();
        }, 600); // 缩短动画时间
    },
    startAutoplay() {
        // 清除已存在的定时器，避免多个定时器叠加
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = setInterval(this.nextSlide, 4500); // 每4.5秒切换一次轮播图
    },
    onVideo() {
        const isVideo =
            this.homeBannerList[this.currentIndex] &&
            this.homeBannerList[this.currentIndex].video;
        if (!isVideo) return;
        clearInterval(this.autoplayInterval); // 暂停轮播
        
        // 切换视频播放状态
        this.videoIsPlay = !this.videoIsPlay;
        this.videoPaused = !this.videoIsPlay; // 同步更新videoPaused状态
        
        const video =
            (this.$refs[`vueMiniPlayer${this.currentIndex}`] &&
                this.$refs[`vueMiniPlayer${this.currentIndex}`][0]) ||
            null;
            
        if (video) {
            if (this.videoIsPlay) {
                // 播放视频
                video.play().catch((error) => {
                    console.error("播放错误:", error);
                });
            } else {
                // 暂停视频
                video.pause();
            }
        }
        
        // 如果视频暂停，延迟恢复自动播放
        if (!this.videoIsPlay) {
            setTimeout(() => {
                this.startAutoplay();
            }, 3000);
        }
    },
    onVideoPlay() {
      this.videoIsPlay = true;
      this.videoPaused = false;
      clearInterval(this.autoplayInterval); // 暂停轮播
    },
    onVideoPause() {
      this.videoIsPlay = false;
      this.videoPaused = true;
    },
    onVideoEnded() {
        clearInterval(this.autoplayInterval); // 暂停轮播
        this.videoIsPlay = false; // 更新视频播放状态
        this.videoPaused = true; // 更新视频暂停状态

        const video =
            (this.$refs[`vueMiniPlayer${this.currentIndex}`] &&
                this.$refs[`vueMiniPlayer${this.currentIndex}`][0]) ||
            null;
        // 视频结束后延迟恢复自动播放
        setTimeout(() => {
            this.startAutoplay();
        }, 3000);
    },
    // 处理鼠标滚轮事件（触控板支持）
    handleWheel(event) {
        // 如果视频正在播放，则不允许滚轮切换
        if (this.videoIsPlay) return;
        
        // 防抖机制，避免过快滚动导致的误操作
        const now = Date.now();
        if (now - this.lastWheelTime < 300) {
            return;
        }
        this.lastWheelTime = now;
        
        // 只处理水平滚动或主要为水平方向的滚动
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
            // 主要为垂直滚动，允许页面滚动，不阻止默认行为
            return;
        }
        
        // 防止在切换过程中再次触发
        if (this.wheelScrolling) {
            return;
        }
        
        // 检测是否为惯性滚动
        // 惯性滚动的特点是短时间内连续触发且滚动幅度较小
        const timeDiff = now - (this.lastWheelEventTime || 0);
        const deltaDiff = Math.abs(event.deltaX - (this.lastWheelDeltaX || 0));
        
        // 如果是惯性滚动（时间间隔短且滚动幅度小），则忽略
        // 对于鼠标滚动，我们设置更严格的条件
        if (timeDiff < 100 && Math.abs(event.deltaX) < 20) {
            return;
        }
        
        // 记录当前滚动事件信息用于下次判断
        this.lastWheelEventTime = now;
        this.lastWheelDeltaX = event.deltaX;
        
        // 阻止水平滚动的默认行为，用于轮播图切换
        event.preventDefault();
        
        // 设置滚动锁定标志
        this.wheelScrolling = true;
        
        clearInterval(this.autoplayInterval);
        
        // 只有当滚动幅度足够大时才触发切换
        if (Math.abs(event.deltaX) > 15) {
            if (event.deltaX > 0) {
                // 向右滚动，切换到下一张
                this.nextSlide();
            } else if (event.deltaX < 0) {
                // 向左滚动，切换到上一张
                this.prevSlide();
            }
        }
        
        // 延迟重置滚动锁定标志，确保一次只切换一张图片
        setTimeout(() => {
            this.wheelScrolling = false;
            this.startAutoplay();
        }, 500);
    },
  },
};
</script>
<style scoped>
.index-banner-home {
  position: relative;
  max-height: 960px;
  height: calc(100vw * 0.5); /* AI-Generated */
  width: 100%;
  margin: 0 auto;
  overflow: hidden; /* AI-Generated */
}
.carousel {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%; /* AI-Generated */
}

.carousel.no-interaction {
  pointer-events: none;
}
.banner-bg-wrapper {
  position: relative;
  display: block;
  max-height: 960px;
  width: 100%;
  overflow: hidden;
  height: 100%; /* AI-Generated */
}
.video {
  height: 100%; /* AI-Generated */
  width: 100%;
  object-fit: cover; /* 确保视频填满容器 */
  z-index: 0; /* 确保视频在底层 */
}
.video-click {
  position: absolute;
  left: 45px;
  bottom: 55px;
  z-index: 99;
  width: 100px;
  background-color: #f0060600;
  height: 40px;
  text-align: center;
  cursor: pointer;
}
.video-click-img {
  width: 30px;
  height: 30px;
  object-fit: contain;
}
.overlay-image {
  position: absolute; /* 绝对定位 */
  top: 0; /* 顶部对齐 */
  left: 0; /* 左侧对齐 */
  width: 100%; /* 宽度100% */
  height: 100%; /* 高度100% */
  object-fit: cover; /* 保持宽高比并裁剪 */
  z-index: 1; /* 确保在其他元素之上 */
}

.carousel-slides {
  position: relative;
  display: flex;
  width: 100%; /* 假设有三个轮播项，每个轮播项宽100% */
  height: 100%; /* AI-Generated */
  transition: transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1); /* 更流畅的缓动函数，缩短动画时间 */
  transform: translateX(-100%);
  color: #000;
}
.carousel-slides .pc {
  width: 100%;
  height: 100%; /* AI-Generated */
  object-fit: cover;
  display: block; /* AI-Generated */
}
.carousel-slides .wap {
  display: none;
}
.home-swiper-pagination {
  position: relative;
  width: 1400px;
  margin: 0 auto;
}
.carousel-slide {
  position: relative;
  flex: 0 0 100%;
  min-width: 100%;
  text-align: left;
  height: 100%; /* AI-Generated */
}

.carousel-slide.active {
  /* 实际上，由于我们使用了transform来定位活动轮播项，所以不需要这个类 */
}
.carousel-pagination {
  position: absolute;
  left: 5px;
  bottom: 60px;
  display: flex;
  justify-content: flex-start;
  margin-top: 10px;
  height: 20px;
}

.carousel-pagination-button {
  margin: auto 4px !important;
  opacity: 1;
  width: 20px;
  height: 4px;
  background: url(../assets/diandian_grey.png) no-repeat center;
  background-size: contain;
  cursor: pointer;
  position: relative;
}

.carousel-pagination-button::before {
  content: '';
  position: absolute;
  top: -20px;
  left: -8px;
  right: -8px;
  bottom: -20px;
  cursor: pointer;
}

.carousel-pagination-button.active {
  width: 20px;
  height: 4px;
  background: none;
  position: relative;
  background: url(../assets/diandian_highllight.png) no-repeat center;
  background-size: contain;
}

.carousel-pagination-button.active::before {
  content: '';
  position: absolute;
  top: -20px;
  left: -8px;
  right: -8px;
  bottom: -20px;
  cursor: pointer;
}

.carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: #000;
  border: none;
  cursor: pointer;
  z-index: 10;
}

.banner-heart {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
  max-height: 960px;
  z-index: 12;
  display: flex;
  align-items: center;
  justify-content: center;
}

.videoShow {
  max-width: 800px;
}
.home-img-info {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;

  height: auto;
  z-index: 9999;
  transform: scale(1);
}
.home-img-author {
  font-family: SourceHanSansCN-Regular;
  color: #ffffff;
  font-size: 60px;
  font-weight: Bold;
  margin-top: -6px;
}
.home-img-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #ffffff;
  font-weight: Regular;
}
.home-img-dec {
  font-family: SourceHanSansCN-Regular;
  font-size: 24px;
  color: #ffffff;
  font-weight: Regular;
}
.home-img-btn {
  width: 139px;
  height: 55px;
  margin-top: 21px;
  cursor: pointer;
}
.home-img-btn img {
  width: 139px;
  height: 55px;
  object-fit: cover;
}
.mouse-move-to {
  z-index: 999;
  position: absolute;
  bottom: 60px;
  width: 24px;
  height: 38px;
}
.mouse-move-to img {
  width: 24px;
  height: 38px;
}
.show-act-box {
  width: 90%;
  max-width: 1400px;
  margin: 0 auto 120px;
}
.act-list {
  max-width: 1400px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.content-title {
  width: 100%;
  max-width: 1400px;
  margin-top: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title-left {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #ca9d76;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.title-right {
  position: relative;
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #98989f;
  text-align: left;
  font-weight: 400;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.youjiantou {
  width: 17px;
  height: 20px;
  margin: 2px 0 0 5px;
}
.sub-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 34px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: Bold;
  margin-top: 10px;
}
.sub-title-Architecture {
  font-family: SourceHanSansCN-Bold;
  font-size: 26px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: Regular;
  margin-top: 10px;
}
.sub-title-top {
  font-size: 26px;
  color: #000000;
  text-align: left;
  margin-top: 10px;
}
@keyframes rotate {
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
@media (max-width: 1650px) {
  .home-swiper-pagination {
    position: relative;
    width: 90%;
    margin: 0 auto;
  }
  .carousel-pagination {
  left: 10px;

}
}
@media (max-width: 1520px) {
  .act-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .home-swiper-pagination {
    position: relative;
    max-width: 90%;
    margin: 0 auto;
  }
  .carousel-pagination {
    left: 0px;

  }
  .mouse-move-to {
    z-index: 999;
    position: absolute;
    left: 0;
    bottom: 40px;
    width: 24px;
    height: 38px;
  }
  .banner-heart {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 100%;
    max-height: 960px;
    z-index: 12;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .home-img-info{
    width: 90%;
  }
  .home-img-author {
    font-family: SourceHanSansCN-Regular;
    color: #ffffff;
    font-size: 50px;
    font-weight: Bold;
    margin-top: -6px;
  }
  .youjiantou {
    width: 14px;
    height: 16px;
  }
  .home-img-btn {
    width: 94px;
    height: auto;
    margin-top: 21px;
    font-size: 22px;
    cursor: pointer;
  }
  .home-img-btn img {
    width: 94px;
    height: auto;
    object-fit: contain;
  }
}

@media (max-width: 1200px) {
  .index-banner {
    min-height: calc(100vw * 0.43);
  }
  .index-banner .pc {
    display: none;
    object-fit: cover;
  }
  .index-banner .wap {
    display: block;
    min-height: calc(100vw * 0.43);
  }
  .index-banner .content {
    display: none;
  }
  .banner-heart {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 100%;
    max-height: 960px;
    z-index: 12;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .home-img-info{
    width: 90%;
  }
  .home-img-author {
    font-family: SourceHanSansCN-Regular;
    font-size: 25px;
    color: #ffffff;
    font-weight: 400;
  }
  .home-img-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 40px;
    color: #ffffff;
    font-weight: 700;
  }
  .home-img-dec {
    font-family: SourceHanSansCN-Regular;
    font-size: 20px;
    color: #ffffff;
    font-weight: 400;
  }
  .mouse-move-to {
    position: absolute;
    left: 0%;
    bottom: 40px;
    width: 24px;
    height: 38px;
  }
  .mouse-move-to img {
    width: 24px;
    height: 38px;
  }
  .show-act-box {
    width: 98%;
    margin: 0 auto 60px;
  }
  .act-list {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
  }
  .content-title {
    width: 90%;
    margin: 40px 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .title-left {
    font-family: SourceHanSansCN-Bold;
    font-size: 26px;
    color: #ca9d76;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
  }
  .title-right {
    position: relative;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    color: #98989f;
    text-align: left;
    font-weight: 400;
    padding-right: 15px;
    cursor: pointer;
  }
  .sub-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 18px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
    margin-top: 10px;
  }
  .home-swiper-pagination {
    position: relative;
    max-width: 90%;
    margin: 0 auto;
  }
  .sub-title-Architecture {
    width: 90%;
    margin-left: 20px;
    font-family: SourceHanSansCN-Bold;
    font-size: 20px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
    margin-top: 10px;
  }
}

@media (max-width: 960px) {
  .index-banner-home {
    position: relative;
    min-height: 750px;
  }
  .video {
    min-height: 750px;
    width: 100%;
    object-fit: cover; /* 确保视频填满容器 */
  }
  .video-click {
    position: absolute;
    left: 0px;
    bottom: 50px;
    z-index: 99;
    width: 100px;
    background-color: #f0060600;
    height: 40px;
    text-align: center;
    cursor: pointer;
  }
  .carousel {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .carousel-slides {
    position: relative;
    display: flex;
    width: 100%; /* 假设有三个轮播项，每个轮播项宽100% */
    transition: transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1); /* 更流畅的缓动函数，缩短动画时间 */
    transform: translateX(-100%);
    color: #000;
  }
  .carousel-slides .pc {
    display: none;
  }
  .carousel-slides .wap {
    display: block;
    width: 100%;
    min-height: 750px;
    object-fit: cover;
  }
  .home-swiper-pagination {
    position: relative;
    margin: 0 auto;
  }
  .carousel-slide {
    position: relative;
    flex: 0 0 100%;
    min-width: 100%;
    text-align: left;
  }

  .carousel-slide.active {
    /* 实际上，由于我们使用了transform来定位活动轮播项，所以不需要这个类 */
  }

  .carousel-pagination {
    position: absolute;
    left: 0%;
    bottom: 30px;
    width: 90%;
    display: flex;
    justify-content: flex-start;
    margin-top: 10px;
  }

  .carousel-pagination-button {
    margin: auto 3px !important;
    opacity: 1;
    width: 16px;
    height: 3px;
    background: url(../assets/diandian_grey.png) no-repeat center;
    background-size: contain;
    cursor: pointer;
  }

  .carousel-pagination-button.active {
    width: 16px;
    height: 3px;
    background: none;
    position: relative;
    background: url(../assets/diandian_highllight.png) no-repeat center;
    background-size: contain;
  }

  .carousel-control {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.5);
    color: #000;
    border: none;
    cursor: pointer;
    z-index: 10;
  }

  .home-img-author {
    font-family: SourceHanSansCN-Regular;
    color: #ffffff;
    font-size: 36px;
    font-weight: Bold;
    margin-top: -6px;
  }
  .home-img-title {
    width: 370px;
    font-family: SourceHanSansCN-Bold;
    font-size: 24px;
    color: #ffffff;
    font-weight: Regular;
  }
  .home-img-dec {
    font-family: SourceHanSansCN-Regular;
    font-size: 18px;
    color: #ffffff;
    font-weight: Regular;
  }
  .banner-heart {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    height: 100%;
    max-height: 960px;
    z-index: 12;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .home-img-info{
    width: 100%;
  }
  .home-img-btn {
    width: 90px;
    height: auto;
    margin-top: 21px;
    font-size: 16px;
    cursor: pointer;
  }
  .home-img-btn img {
    width: 90px;
    height: auto;
    object-fit: contain;
  }
  .mouse-move-to {
    display: none;
  }
  .show-act-box {
    margin: 0 auto 24px;
  }
  .act-list {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
  }
  .content-title {
    width: 92%;
    margin: 25px 0 0 4%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .title-left {
    font-size: 26px;
  }
  .title-right {
    position: relative;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #98989f;
    text-align: right;
    font-weight: 400;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding-right: 0;
  }
  .sub-title-Architecture {
    margin: 10px 4% 0;
    font-size: 18px;
  }
  .youjiantou {
    width: 10px;
    height: 12px;
  }
}
@media (max-width: 568px) {
  .index-banner-home {
    position: relative;
    min-height: 600px;
  }
  .video {
    min-height: 600px;
  }
  .video-click {
    position: absolute;
    left: 0px;
    bottom: 50px;
    z-index: 99;
    width: 100px;
    background-color: #f0060600;
    height: 40px;
    text-align: center;
    cursor: pointer;
  }
  .carousel-slides .wap {
    display: block;
    width: 100%;
    min-height: 600px;
    object-fit: cover;
  }
  .banner-heart {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    height: 100%;
    max-height: 960px;
    z-index: 12;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .home-img-info{
    width: 100%;
  }
  .sub-title-Architecture {
    margin: 10px 4% 0;
    font-size: 18px;
  }
  .title-right {
    font-size: 14px;
  }
}
</style>